import reactStringReplace from "react-string-replace";
import { Typography } from "src/components-mui/base/typography/typography";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";

interface IAlphaPerformanceValueProps {
    text: string;
    value: number;
}

export const AlphaWithPerformanceValue = ({ text, value }: IAlphaPerformanceValueProps) => {
    const { formatPerformance } = useNumberFormatter();

    return reactStringReplace(text, "<<performance>>", (_, index) => (
        <Typography
            component="span"
            key={index}
            sx={{
                color: "teal.600",
                fontWeight: "semibold",
            }}
        >
            {formatPerformance(value, 1)}
        </Typography>
    ));
};
